var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('ve-map',{ref:"map-echarts",staticClass:"map-echarts",attrs:{"data":_vm.optionData.data,"backgroundColor":_vm.optionData.backgroundColor,"title":_vm.optionData.title,"tooltip":_vm.optionData.tooltip,"visualMap":_vm.optionData.visualMap,"series":_vm.optionData.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }